import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const paychecksClientRoutes = [
  {
    id: 'paychecks-home',
    trackingName: 'View Paychecks Home',
    path: 'dl/view/paychecks/home',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/paychecks')
    },
  },
  {
    id: 'paychecks-distribution-summary',
    trackingName: 'View Paychecks Distribution Summary',
    path: 'dl/view/paychecks/distribution-summary',
    lazy: async () => ({
      Component: (await import('@cash-web/account-paycheck-feature-main')).JourneyEditDistributions,
    }),
  },
  {
    id: 'paychecks-add-or-edit-allocation',
    trackingName: 'Add or Edit Paychecks Allocation',
    path: 'web/view/paychecks/edit-allocation/:paychecksAllocationId',
    lazy: async () => ({
      Component: (await import('@cash-web/account-paycheck-feature-main')).JourneyAddOrEditAllocation,
    }),
  },
  {
    id: 'paychecks-view-paychecks-activity',
    trackingName: 'View Paychecks Activity',
    path: 'web/view/paychecks/activity',
    lazy: async () => ({
      Component: (await import('@cash-web/account-paycheck-feature-main')).JourneyViewPaychecksActivity,
    }),
  },
  {
    id: 'paychecks-view-paycheck',
    trackingName: 'View Paycheck',
    path: 'web/view/paychecks/view-paycheck',
    lazy: async () => ({
      Component: (await import('@cash-web/account-paycheck-feature-main')).JourneyViewPaycheck,
    }),
  },
] as const satisfies JourneyRoute[]
